import { Module, VuexModule, Action } from 'vuex-module-decorators';
import axios from 'axios';
import { toError, assertOk } from '@/services/normalize';
import {
  BASE_URL,
  AGENT_LOGIN_ALLOW_LIST,
  AGENT_LOGIN_ALLOW_ADD,
  AGENT_LOGIN_ALLOW_UPDATE,
  AGENT_LOGIN_ALLOW_REMOVE,
  M_POST
} from '@/utils/api';
import type { IAgentLoginAllowAdd, IAgentLoginAllowUpdate, IAgentLoginAllowRemove } from '@/interface/AgentLoginAllow';

@Module({ name: 'agent-login-allow' })
export default class AgentLoginAllow extends VuexModule {
  @Action({ rawError: true })
  async FetchAgentLoginAllowList() {
    try {
      const { data } = await axios({
        url: BASE_URL + AGENT_LOGIN_ALLOW_LIST,
        method: M_POST,
        data: {}
      });

      assertOk(data, 'Fetch agent login allow list failed');
      return data?.data ?? data;
    } catch (err: any) {
      throw toError(err, 'Fetch agent login allow list failed');
    }
  }

  @Action({ rawError: true })
  async AddAgentLoginAllow(params: IAgentLoginAllowAdd) {
    try {
      const { data } = await axios({
        url: BASE_URL + AGENT_LOGIN_ALLOW_ADD,
        method: M_POST,
        data: params
      });

      assertOk(data, 'Add agent login allow failed');
      return data?.data ?? data;
    } catch (err: any) {
      throw toError(err, 'Add agent login allow failed');
    }
  }

  @Action({ rawError: true })
  async UpdateAgentLoginAllow(params: IAgentLoginAllowUpdate) {
    try {
      const { data } = await axios({
        url: BASE_URL + AGENT_LOGIN_ALLOW_UPDATE,
        method: M_POST,
        data: params
      });

      assertOk(data, 'Update agent login allow failed');
      return data?.data ?? data;
    } catch (err: any) {
      throw toError(err, 'Update agent login allow failed');
    }
  }

  @Action({ rawError: true })
  async RemoveAgentLoginAllow(params: IAgentLoginAllowRemove) {
    try {
      const { data } = await axios({
        url: BASE_URL + AGENT_LOGIN_ALLOW_REMOVE,
        method: M_POST,
        data: params
      });

      assertOk(data, 'Remove agent login allow failed');
      return data?.data ?? data;
    } catch (err: any) {
      throw toError(err, 'Remove agent login allow failed');
    }
  }
}
